export enum LanguageId {
    NONE = 0,
    LANGUAGE_ENGLISH = 1,
    LANGUAGE_DUTCH = 2,
    LANGUAGE_GERMAN = 3,
}
